var map = {
	"./2020.md": "./content/2020.md",
	"./2021.md": "./content/2021.md",
	"./2022.md": "./content/2022.md",
	"./2023.md": "./content/2023.md",
	"./books.md": "./content/books.md",
	"./doing-centric.md": "./content/doing-centric.md",
	"./impact-through-intimacy.md": "./content/impact-through-intimacy.md",
	"./personal-ai-ethics.md": "./content/personal-ai-ethics.md",
	"./primer.md": "./content/primer.md",
	"./sdac.md": "./content/sdac.md",
	"./sight-reading.md": "./content/sight-reading.md",
	"./stillness.md": "./content/stillness.md",
	"./worth-learning-agi.md": "./content/worth-learning-agi.md",
	"./woz-learning.md": "./content/woz-learning.md"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./content sync recursive ^\\.\\/.*\\.md$";